var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"submission-overlay"},[_c('div',{staticClass:"submission-overlay-content"},[_vm._m(0),_c('h3',{staticClass:"submission-title"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"submission-message"},[_vm._v(_vm._s(_vm.message))])])]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner-container"},[_c('div',{staticClass:"spinner"})])
}]

export { render, staticRenderFns }